export const LoadingMessages = {
  'auth.checkSession': 'Checking session...',
  'auth.prepare': 'Preparing...',
  'auth.verifyFlow': 'Please wait while we prepare everything for you',
  'auth.validateReset': 'Validating your reset link...',
  'verifying.email': 'Verifying your email...',
  'verifying.emailChange': 'Verifying your email change...',
  'app.loading': 'Loading...',
  'route.loadingPage': 'Loading...',
};

export const getLoadingMessage = (key, fallback = 'Loading...') => {
  return LoadingMessages[key] || fallback;
};


